import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard, 
  Users, 
  CheckSquare, 
  Settings, 
  MessageSquare, 
  FileText, 
  Eye, 
  UserCheck, 
  Briefcase, 
  Calendar,
  Plus,
  BarChart3,
  FolderOpen,
  Menu,
  X,
  Trash2
} from 'lucide-react';
import agencyLogo from '../../assets/naim-tech-agency-logo-official.png';

const navigationItems = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/candidates', icon: Users, label: 'Candidates' },
  { to: '/cv-builder', icon: FileText, label: 'CV Builder' },
  { to: '/documents', icon: FolderOpen, label: 'Documents' },
  { to: '/associates', icon: UserCheck, label: 'Associates' },
  { to: '/receptionist-view', icon: Eye, label: 'Receptionist View' },
  { to: '/tasks', icon: CheckSquare, label: 'Tasks' },
  { to: '/appointments', icon: Calendar, label: 'Appointments' },
  { to: '/jobs', icon: Briefcase, label: 'Jobs' },
  { to: '/job-generator', icon: Plus, label: 'Job Generator' },
  { to: '/reports', icon: BarChart3, label: 'Reports' },
  { to: '/settings', icon: Settings, label: 'Settings' },
  { to: '/recycle-bin', icon: Trash2, label: 'Recycle Bin' }
];

interface SidebarProps {
  collapsed: boolean;
  onToggle: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ collapsed, onToggle }) => {
  return (
    <div className={`${
      collapsed 
        ? 'w-16 lg:w-16' 
        : 'w-full lg:w-64'
    } bg-white shadow-md border-r lg:border-r border-b lg:border-b-0 border-gray-200 transition-all duration-300 ease-in-out lg:min-h-screen flex-shrink-0`}>
      <div className={`${collapsed ? 'p-3' : 'p-4 lg:p-6'} border-b border-gray-200 transition-all duration-300`}>
        <div className="flex items-center justify-between">
          {!collapsed && (
            <div>
              <img
                src={agencyLogo}
                alt="Naim Tech Agency"
                className="h-36 w-auto"
              />
            </div>
          )}
          <button
            onClick={onToggle}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors text-[#8b6914]"
            title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            {collapsed ? <Menu className="w-5 h-5" /> : <X className="w-5 h-5" />}
          </button>
        </div>
        {collapsed && (
          <div className="mt-2 text-center">
            <div className="w-8 h-8 bg-[#8b6914] rounded-full flex items-center justify-center mx-auto">
              <span className="text-white font-bold text-sm">NI</span>
            </div>
          </div>
        )}
      </div>
      
      <nav className={`${collapsed ? 'p-2' : 'p-2 lg:p-4'} transition-all duration-300`}>
        <ul className={`space-y-1 lg:space-y-2 ${collapsed ? '' : 'flex lg:block overflow-x-auto lg:overflow-x-visible space-x-2 lg:space-x-0 pb-2 lg:pb-0'}`}>
          {navigationItems.map((item) => (
            <li key={item.to} className={collapsed ? '' : 'flex-shrink-0 lg:flex-shrink'}>
              <NavLink
                to={item.to}
                className={({ isActive }) =>
                  `flex items-center ${collapsed ? 'justify-center p-2 lg:p-3' : 'space-x-2 lg:space-x-3 px-2 py-2 lg:px-3 lg:py-2 whitespace-nowrap'} rounded-lg transition-colors ${
                    isActive
                      ? 'bg-[#8b6914] text-white'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`
                }
                title={collapsed ? item.label : undefined}
              >
                <item.icon className="w-5 h-5" />
                {!collapsed && <span className="text-sm font-medium">{item.label}</span>}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
